import { selectActiveFeatures } from './selectActiveFeatures';
import { IApplicationState } from '../../types/redux';

export function selectActiveFeaturesCount(state: IApplicationState): number {
  const layerFeatures = selectActiveFeatures(state);

  return Object.values(layerFeatures).length;
}
